import { render, staticRenderFns } from "./page3.vue?vue&type=template&id=3c40a7b0&"
import script from "./page3.vue?vue&type=script&lang=js&"
export * from "./page3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports